import { format } from 'date-fns'
import {
  RescheduleAppointmentData,
  RescheduleAppointmentDataMapper,
} from './RescheduleAppointmentMapper.types'

class RescheduleAppointmentMapper {
  toPersistence(domainData: RescheduleAppointmentDataMapper) {
    const date = domainData?.date ? new Date(domainData.date) : null

    if (date && !isNaN(Number(date))) {
      const dateFormatted = format(date, 'dd/MM/yyyy')

      const dateToPayload = `${dateFormatted} ${domainData?.hour}`

      const payload: RescheduleAppointmentData = {
        data: dateToPayload,
        token: domainData?.token,
      }

      if (domainData?.isPV) {
        payload.scheduleId = domainData?.scheduleId
      }

      return payload
    }
  }
}

export default new RescheduleAppointmentMapper()
